export default __webpack_public_path__ + "static/media/icon-market.9e95abb6.svg";